import Vue from 'vue';
import Router from 'vue-router';

const Page1 = () => import('@templates/page1');
const Page2 = () => import('@templates/page2');
const Page3 = () => import('@templates/page3');
const Page4 = () => import('@templates/page4');
const Start = () => import('@templates/start');
const Register = () => import('@templates/register');
const Login = () => import('@templates/login');
const Locations = () => import('@templates/locations');
const Menu = () => import('@templates/menu');
const Basket = () => import('@templates/basket');
const Checkout = () => import('@templates/checkout');
const Complete = () => import('@templates/complete');
const ResetPassword = () => import('@components/resetPassword');
const Offline = () => import('@templates/offline');

Vue.use(Router);

export default new Router({
	// mode: 'history',
	routes: [
		{
			path: '/register',
			name: 'Register',
			component: Register,
			props: true,
			meta: {
				reset: true,
				resetBraintree: true
			}
		},
		{
			path: '/login',
			name: 'Login',
			component: Login,
			props: true,
			meta: {
				reset: true,
				resetBraintree: true
			}
		},
		{
			path: '/page1',
			name: 'Page 1',
			component: Page1,
			props: true,
			meta: {
				reset: true,
				resetBraintree: true
			}
		},
		{
			path: '/page2',
			name: 'Page 2',
			component: Page2,
			props: true,
			meta: {
				reset: true,
				resetBraintree: true
			}
		},
		{
			path: '/page3',
			name: 'Page 3',
			component: Page3,
			props: true,
			meta: {
				reset: true,
				resetBraintree: true
			}
		},
		{
			path: '/page4',
			name: 'Page 4',
			component: Page4,
			props: true,
			meta: {
				reset: true,
				resetBraintree: true
			}
		},
		{
			path: '/',
			name: 'Start',
			component: Start,
			props: true,
			meta: {
				reset: true,
				resetBraintree: true
			}
		},
		{
			path: '/locations/:siteId',
			name: 'LocationsDynamic',
			component: Locations,
			props: true,
			meta: {
				reset: true,
				resetBraintree: true,
				clearMenus: true
			}
		},
		{
			path: '/locations',
			name: 'Locations',
			component: Locations,
			props: true,
			meta: {
				reset: true,
				resetBraintree: true,
				clearMenus: true
			}
		},
		{
			path: '/menu',
			name: 'Menu',
			component: Menu,
			props: true,
			meta: {
				requiresSiteId: true,
				resetBraintree: true
			}
		},
		{
			path: '/basket',
			name: 'Basket',
			component: Basket,
			props: true,
			meta: {
				requiresABasket: true,
				resetBraintree: true
			}
		},
		{
			path: '/checkout',
			name: 'Checkout',
			component: Checkout,
			props: true,
			meta: {
				requiresAuth: true,
				requiresABasket: true
			}
		},
		{
			path: '/complete',
			name: 'Complete',
			component: Complete,
			props: true,
			meta: {
				requiresAuth: true,
				requiresBasketId: true
			}
		},
		{
			path: '/reset-password',
			name: 'ResetPassword',
			component: ResetPassword,
			props: true
		},
		{
			path: '/offline',
			name: 'Offline',
			component: Offline,
			props: true
		}
	]
});



// WEBPACK FOOTER //
// ./src/vue/router.js